import { CalculationMethodEnum } from './enums/calculation-method.enum';
import { PricingOptionType } from './enums/pricing-option-type.enum';
import { TransportStep } from './enums/transport-step.enum';
import { Offer } from './offer.model';

export interface IPricingOption {
  id?: number;
  nameKey: string;
  name?: string | null;
  value: number;
  quotationNeeded?: boolean | null;
  calculationMethod?: CalculationMethodEnum | null;
  type?: PricingOptionType | null;
  step?: TransportStep | null;
  offer?: Offer;
}

export class PricingOption implements IPricingOption {
  public nameKey!: string;
  public name?: string;
  public value!: number;
  public id?: number;
  public quotationNeeded: boolean = false;
  public calculationMethod?: CalculationMethodEnum;
  public type?: PricingOptionType;
  public step?: TransportStep;
  public offer?: Offer;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  public serialize(): any {
    return this;
  }
}
